import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobEducation, deleteJobEducation, fetchJobEducation, updateJobEducation } from "./JobEducationAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobEducationAsync = createAsyncThunk(
  "jobEducation/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobEducation();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const addJobEducationAsync = createAsyncThunk(
  "jobEducation/add",
  async (newJobEducation) => {
    try {
      const data = await addJobEducation(newJobEducation);
      // console.log("data in slice", data)
      return data;
    } catch (error) {
      // console.log("errorL :" , error)
      return error
      // return rejectWithValue(error.message);
    }
  }
);



export const deleteJobEducationAsync = createAsyncThunk(
  'jobEducation/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobEducation(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobEducationAsync = createAsyncThunk(
  'jobEducation/update',
  async ({ uuid, jobEducationData }, { rejectWithValue }) => {
    try {
      const response = await updateJobEducation(uuid, jobEducationData);
      // console.log("Response Slice", response)
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const jobEducationSlice = createSlice({
  name: "jobEducation",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(addJobEducationAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobEducationAsync.rejected, (state, action) => {
        state.error = action.payload;
      })

      // .addCase(updateJobEducationAsync.pending, (state) => {
      //   state.loading = true;
      //   console.log("Loading")
      //   state.error = null;
      // })
      // .addCase(updateJobEducationAsync.fulfilled, (state, action) => {
      //   // state.loading = false;
      //   // console.log("data", state.data)
      //   // state.data = state.data.map((jobEducation) =>
      //   //   jobEducation.uuid === action.payload.uuid ? action.payload : jobEducation
      //   // );
      //   state.status = 'succeeded';
      //   const index = state.data.findIndex(job => job.uuid === action.payload.uuid);
      //   if (index !== -1) {
      //     state.jobEducations[index] = action.payload;
      //   }
      // })
      // .addCase(updateJobEducationAsync.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      .addCase(updateJobEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.data) {
          state.data = [];
        }
        state.data = state.data.map((jobTitle) =>
          jobTitle.uuid === action.payload.uuid ? action.payload : jobTitle
        );
      })
      .addCase(updateJobEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteJobEducationAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobEducationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((title) => title.uuid !== action.payload);
      })
      .addCase(deleteJobEducationAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const selectJobEducation = (state) => state.jobEducation.data;

export default jobEducationSlice.reducer;
